import { useProductDetailState } from 'contexts';
import Head from 'next/head';
import { MAX_ITEMS_WITH_TWO_BLOCKS, RelatedBlock } from './RelatedBlock';

export const RelatedVideos = () => {
  const { product } = useProductDetailState();

  const { relatedVideos } = product?.seoInfo || {};

  if (!relatedVideos?.urls?.length) {
    return null;
  }

  return (
    <>
      {!!relatedVideos?.urls?.length && (
        <Head>
          {relatedVideos.urls.map((video, index) => {
            return (
              <script
                key={`${index}${video.url}`}
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'VideoObject',
                    name: video.name,
                    description: video.description,
                    thumbnailUrl: video.thumbnailUrl,
                    uploadDate:
                      typeof video.uploadDate === 'number'
                        ? new Date(video.uploadDate * 1000).toISOString()
                        : '',
                    embedUrl: video.url,
                  }),
                }}
              />
            );
          })}
        </Head>
      )}
      <RelatedBlock
        title={relatedVideos?.title || ''}
        seeMoreUrl={relatedVideos?.seeMoreUrl}
        type="video"
        items={
          relatedVideos?.urls
            ?.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS)
            .map(({ url, thumbnailUrl, description }) => {
              return {
                url: url || '',
                thumbnailUrl: thumbnailUrl || '',
                description: description || '',
              };
            }) || []
        }
      />
    </>
  );
};
